import { isDeviceNetworkConnected } from '@/helpers/networkLinkConnectivity'

export type TPlayerNetworkChipTone = 'online' | 'degraded' | 'offline'

export interface TPlayerNetworkChipDisplay {
  tone: TPlayerNetworkChipTone
  /** Short label inside the header chip. */
  label: string
  /** Optional second line under the chip (Android link detail). */
  detail: string | null
}

export function resolvePlayerNetworkChip(input: {
  navigatorOnline: boolean
  wifiEnabled?: boolean | null
  transportConnected?: boolean | null
  wsConnected: boolean
  poolingServiceRunning: boolean
}): TPlayerNetworkChipDisplay {
  const wsConnected = input.wsConnected
  const pooling = input.poolingServiceRunning
  const linkUp = isDeviceNetworkConnected({
    wifiEnabled: input.wifiEnabled,
    transportConnected: input.transportConnected,
    navigatorOnline: input.navigatorOnline
  })

  if (!linkUp) {
    if (input.wifiEnabled === false && input.transportConnected !== true) {
      return {
        tone: 'offline',
        label: 'Wi-Fi desligado',
        detail: pooling ? 'Polling HTTP · sem Wi-Fi' : null
      }
    }
    return {
      tone: 'offline',
      label: 'Sem rede',
      detail: null
    }
  }

  if (wsConnected && !pooling) {
    return {
      tone: 'online',
      label: 'WebSocket',
      detail: null
    }
  }

  if (pooling && !wsConnected) {
    return {
      tone: 'degraded',
      label: 'Rede instável',
      detail: 'Polling HTTP · WebSocket indisponível'
    }
  }

  if (pooling && wsConnected) {
    return {
      tone: 'degraded',
      label: 'Rede instável',
      detail: 'Polling HTTP ativo'
    }
  }

  return {
    tone: 'online',
    label: 'Online',
    detail: null
  }
}

export function playerNetworkChipToneClass(tone: TPlayerNetworkChipTone): string {
  switch (tone) {
    case 'online':
      return 'border-green-500/35 bg-green-500/15 text-green-300'
    case 'degraded':
      return 'border-amber-500/35 bg-amber-500/15 text-amber-200'
    default:
      return 'border-red-500/35 bg-red-500/15 text-red-300'
  }
}
